import { grid1I1 } from './definitions/grid1I1';
import { grid1I2 } from './definitions/grid1I2';
import { grid1I2x2 } from './definitions/grid1I2x2';
import { grid1I3 } from './definitions/grid1I3';
import { grid1x0 } from './definitions/grid1x0';
import { grid1x0x1 } from './definitions/grid1x0x1';
import { grid1x0x2 } from './definitions/grid1x0x2';
import { grid1x1 } from './definitions/grid1x1';
import { grid1x1x0 } from './definitions/grid1x1x0';
import { grid1x1x1 } from './definitions/grid1x1x1';
import { grid1x2 } from './definitions/grid1x2';
import { grid1x2x0 } from './definitions/grid1x2x0';
import { grid1x2x2 } from './definitions/grid1x2x2';
import { grid2I1 } from './definitions/grid2I1';
import { grid2I1X2 } from './definitions/grid2I1x2';
import { grid2x0x0 } from './definitions/grid2x0x0';
import { grid2x1 } from './definitions/grid2x1';
import { grid2x1x0 } from './definitions/grid2x1x0';
import { grid2x2 } from './definitions/grid2x2';
import { grid2x2I1 } from './definitions/grid2x2I1';
import { grid2x2x0 } from './definitions/grid2x2x0';
import { grid2x2x2 } from './definitions/grid2x2x2';
import { grid2x3 } from './definitions/grid2x3';
import { grid2xFx0 } from './definitions/grid2xFx0';
import { gridF } from './definitions/gridF';
import { gridFx2x0 } from './definitions/gridFx2x0';

import type { GridIdList, GridNameList } from './types';

// Moved to CreativesProvider defaults
export const gridNameList: GridNameList = {
  '1:0': grid1x0(),
  '1:1': grid1x1(),
  '1:2': grid1x2(),
  '2:1': grid2x1(),
  '2:2': grid2x2(),
  '1|1': grid1I1(),
  '1|2': grid1I2(),
  '2|1': grid2I1(),
  '2:2:2': grid2x2x2(),
  '1:2:2': grid1x2x2(),
  '1|2:2': grid1I2x2(),
  '1:0:2': grid1x0x2(),
  '2:1:0': grid2x1x0(),
  '1:0:1': grid1x0x1(),
  '1:1:0': grid1x1x0(),
  '2:3': grid2x3(),
  '1:1:1': grid1x1x1(),
  'F:2:0': gridFx2x0(),
  '2:F:0': grid2xFx0(),
  F: gridF(),
  '1|3': grid1I3(),
  '2|1:2': grid2I1X2(),
  '1:2:0': grid1x2x0(),
  '2:2:0': grid2x2x0(),
  '2:0:0': grid2x0x0(),
  '2:2|1': grid2x2I1(),
};

// Temporary solution, used in case of global grids data absence
export const gridIdList: GridIdList = {
  '1': grid1x0(),
  '2': grid1x1(),
  '3': grid1x2(),
  '4': grid2x1(),
  '5': grid2x2(),
  '11': grid1I1(),
  '12': grid1I2(),
  '13': grid2I1(),
  '14': grid2x2x2(),
  '15': grid1x2x2(),
  '17': grid1I2x2(),
  '18': grid1x0x2(),
  '19': grid2x1x0(),
  '20': grid1x0x1(),
  '21': grid1x1x0(),
  '22': grid2x3(),
  '24': grid1x1x1(),
  '25': gridFx2x0(),
  '26': grid2xFx0(),
  '27': gridF(),
  '57': gridFx2x0(),
  '58': grid2xFx0(),
  '59': gridF(),
  '96': grid1I3(),
  '97': grid2I1X2(),
  '98': grid1x2x0(),
  '99': grid2x2x0(),
  '100': grid2x0x0(),
  '101': grid2x2I1(),
  '28': grid1I3(),
  '29': grid2I1X2(),
  '30': grid1x2x0(),
  '31': grid2x2x0(),
  '32': grid2x0x0(),
  '33': grid2x2I1(),
};
